function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M55.326 91.66c-20.305 0-36.792-16.381-36.792-36.563 0-20.174 16.487-36.56 36.792-36.56h434.568c20.302 0 36.792 16.386 36.792 36.56 0 20.182-16.487 36.564-36.792 36.564H55.326zm409.418 296.77c14.741-13.788 37.979-13.101 51.854 1.555s13.185 37.739-1.565 51.527c-33.98 31.697-72.392 56.944-113.792 74.101-40.502 16.758-83.814 25.849-128.628 25.849-44.822 0-88.132-9.091-128.636-25.849-41.401-17.157-79.81-42.404-113.793-74.101-14.75-13.788-15.44-36.871-1.565-51.527 13.875-14.656 37.113-15.343 51.854-1.555 27.556 25.708 58.492 46.086 91.664 59.821 31.466 13.015 65.275 20.096 100.476 20.096 35.193 0 69.001-7.081 100.467-20.096 33.172-13.733 64.111-34.113 91.664-59.821zm9.621-186.398c18.304-8.521 40.149-.634 48.724 17.562 8.575 18.189 8.46 56.702-9.844 65.223-33.408 15.577-74.88 29.276-114.895 37.538-38.67 8.005-83.526-5.805-125.737-5.805-42.217 0-83.326-4.345-121.999-12.35-40.007-8.264-77.442-20.646-110.817-36.19-18.304-8.52-43.006-38.131-34.434-56.32 8.575-18.196 55.018-34.979 73.33-26.459 28.153 13.131 56.024 22.283 90.612 29.419 37.664 6.218 39.595 6.456 81.297 9.8 37.743 0 95.796 15.236 129.055 8.356 34.587-7.139 66.57-17.676 94.708-30.774z",
  fill: "url(#sygnet_svg__paint0_linear_4816_86)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143.977 515.613c-41.401-17.157-79.81-42.404-113.793-74.101-14.75-13.788-15.44-36.871-1.565-51.527 13.875-14.656 37.113-15.343 51.854-1.555 27.556 25.708 58.492 46.086 91.664 59.821 31.466 13.015 65.275 20.096 100.476 20.096 35.193 0 69.001-7.081 100.467-20.096 33.172-13.733 64.111-34.113 91.664-59.821 14.741-13.788 37.979-13.101 51.854 1.555s13.185 37.739-1.565 51.527c-33.98 31.697-72.392 56.944-113.792 74.101-40.502 16.758-83.814 25.849-128.628 25.849-44.822 0-88.132-9.091-128.636-25.849zm308.11-140.725l-.002.002c-26.069 24.319-55.149 43.421-86.088 56.23-29.305 12.121-60.712 18.689-93.384 18.689-32.679 0-64.084-6.567-93.386-18.687-30.949-12.814-60.034-31.919-86.11-56.247l-.002-.001c-22.171-20.72-57.064-19.701-77.954 2.365-20.939 22.117-19.902 56.999 2.367 77.816l.008.007.007.007c35.481 33.094 75.742 59.603 119.339 77.671l.01.004C179.541 550.388 225.252 560 272.613 560c47.353 0 93.066-9.612 135.712-27.256l.01-.004c43.597-18.068 83.861-44.576 119.34-77.672l.007-.006.007-.007c22.27-20.817 23.306-55.699 2.368-77.816-20.895-22.071-55.8-23.086-77.97-2.351zm-371.614-163.2l-1.78-26.457c26.739 12.472 57.313 22.549 90.612 29.419l.01.002c31.977 6.615 66.76 10.24 103.298 10.24 36.529 0 71.312-3.625 103.29-10.24l.008-.002c33.291-6.871 63.894-16.978 90.634-29.425 27.51-12.806 60.364-1.003 73.308 26.463 12.998 27.571.918 60.314-26.608 73.129m9.844-65.223c-8.575-18.196-30.42-26.083-48.724-17.562-28.138 13.098-60.121 23.635-94.708 30.774-33.259 6.88-91.312-8.356-129.055-8.356-41.702-3.344-43.633-3.582-81.297-9.8-34.588-7.136-62.459-16.288-90.611-29.419-18.313-8.52-64.756 8.263-73.331 26.459-8.572 18.189 16.13 47.8 34.434 56.32 33.375 15.544 70.81 27.926 110.817 36.19 38.673 8.005 79.782 12.35 121.999 12.35 42.211 0 87.067 13.81 125.737 5.805 40.015-8.262 81.487-21.961 114.895-37.538 18.304-8.521 18.419-47.034 9.844-65.223zM398.35 322.355c-39.904 8.26-82.269 12.733-125.737 12.733-43.475 0-85.84-4.473-125.747-12.733-41.335-8.539-80.146-21.356-114.893-37.539C4.448 272.001-7.63 239.26 5.363 211.691M398.35 322.355c41.335-8.534 80.107-21.319 114.894-37.538L398.35 322.355zM78.694 185.231l1.779 26.457-1.78-26.457zm-23.368-75.032C24.897 110.199 0 85.629 0 55.097 0 24.572 24.898 0 55.326 0h434.568c30.424 0 55.326 24.57 55.326 55.097 0 30.532-24.897 55.102-55.326 55.102H55.326zm23.368 75.032c-27.515-12.802-60.386-1.011-73.331 26.459l73.33-26.459zM18.534 55.097c0 20.182 16.487 36.564 36.792 36.564h434.568c20.305 0 36.792-16.382 36.792-36.564 0-20.174-16.49-36.56-36.792-36.56H55.326c-20.305 0-36.792 16.386-36.792 36.56z",
  fill: "url(#sygnet_svg__paint1_linear_4816_86)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  cx: 56.658,
  cy: 55.015,
  r: 36.771,
  stroke: "url(#sygnet_svg__paint2_linear_4816_86)",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  cx: 56.658,
  cy: 417.126,
  r: 36.771,
  stroke: "url(#sygnet_svg__paint3_linear_4816_86)",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sygnet_svg__paint0_linear_4816_86",
  x1: 0,
  y1: 91,
  x2: 545,
  y2: 91,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2F3A5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F3A5F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sygnet_svg__paint1_linear_4816_86",
  x1: 0,
  y1: 91,
  x2: 545,
  y2: 91,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2F3A5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F3A5F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sygnet_svg__paint2_linear_4816_86",
  x1: 18.357,
  y1: 55.79,
  x2: 94.742,
  y2: 55.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8C8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#425CB4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "sygnet_svg__paint3_linear_4816_86",
  x1: 18.357,
  y1: 417.902,
  x2: 94.742,
  y2: 417.615,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8C8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#425CB4"
})));

function SvgSygnet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 546 560",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgSygnet;